import { allStatusesEnum } from '../../campaigns/constants';

export default {
  label: 'Unpause Campaign',
  value: 'Unpause Campaign',
  initialState: () => null,
  patch: () => ({ status: allStatusesEnum.RUNNING.value }),
};
